const TableStaffComponent = () => import('@/views/kpi/TableStaff/TableStaffView')

export default [
    {
        path:'/TableStaffIndex',
        name:'TableStaffComponent',
        component:TableStaffComponent
    }
]